import React from 'react'
import { Box, Typography } from '@mui/material'
import logoCareme from '../../assets/caremeLogoMain.svg'
import style from './PageLayout.module.css'

type PageLayoutProps = {
  children: React.ReactNode
  title?: string
  scrollable?: boolean
  hideLogo?: boolean
  withCard?: boolean
}

export function PageLayout({
  children,
  title,
  scrollable = false,
  hideLogo = false,
  withCard = true,
}: PageLayoutProps) {
  return (
    <div className={style.wrapper}>
      <Box
        className={`${style.container} ${
          scrollable ? style.containerScrollable : style.containerFixed
        }`}
      >
        {title && (
          <div className={style.pageTitle}>
            <Typography>{title}</Typography>
          </div>
        )}

        {withCard ? <Box className={style.innerCard}>{children}</Box> : children}

        {!hideLogo && (
          <Box className={style.logoWrapper}>
            <img src={logoCareme} alt="Logo Careme" className={style.logo} />
          </Box>
        )}
      </Box>
    </div>
  )
}
